import { render, staticRenderFns } from "./HomeworkSubmission.vue?vue&type=template&id=44b0ad50"
import script from "./HomeworkSubmission.vue?vue&type=script&lang=js"
export * from "./HomeworkSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports